import Model from "./base/model";

class Request extends Model {
  resourceName() {
    return "request";
  }

  fields() {
    return {
      company_id: "",
      order_id: "",
      value: "",
      weight: "",
      cubed: "",
      collection_address_id: "",
      delivery_address_id: "",
      road_map_id: "",
      destinatary_name: "",
      destinatary_identification_document: "",
      is_natural_person: "",
      observation: "",
      created_at: "",
      type: "",
      transporter_id:"",
      request_file_id:"",
      files: { jsonApi: "hasMany", type: "request_files"},
      company: { jsonApi: "hasOne", type: "companies"},
      order: { jsonApi: "hasOne", type: "orders"},
      collection_address: { jsonApi: "hasOne", type: "addresses"},
      delivery_address: { jsonApi: "hasOne", type: "addresses"},
      road_map_request: { jsonApi: "hasOne", type: "road_maps_requests"},
      request_file: { jsonApi: "hasOne", type: "request_files"},
      simulations: {jsonApi:"hasMany", type:"request_simulations"},
      selected_simulation:{jsonApi:"hasOne", type:"request_simulations"},
      transporter: { jsonApi: "hasOne", type: "transporters"},
      client_other_transporter: {jsonApi: "hasMany", type:"request_client_other_transporter"},
      simulation_refusal_justification:  {jsonApi: "hasMany", type:"request_simulation_refusal_justification"},
      transporter_fantasy_name: "",
      transporter_cnpj:"",
      transporter_phone:"",
      simulation_refuse_justification: "",
      supplier: {jsonApi: "hasOne", type: "suppliers"},
      external_id: "",
      receive_simulation_emails: "",
      erp_request_number: "",
      need_quotation: "",
      freight_approved_value: "",
      need_freight_approval: "",
      simulation_quote_id: "",
      volumes: "",
      products: {jsonApi: 'hasMany', type:'products'},
      request_invoices: { jsonApi: "hasMany", type: "request_invoices"},
      picking_status: "",
      collection_datetime: "",
      request_products: { jsonApi: 'hasMany', type: 'request_products'},
    };
  }

  async getByHash(hash,params) {
    return this.request(
      this.resourceName()+"/get_by_hash/"+hash,
      "GET",
      params
    )
  }

  async confirmSimulationByHash(hash,simulationId){
    return this.request(
      this.resourceName()+"/confirm_simulation_by_hash/"+hash+"/"+simulationId,
      "POST",
      {},
      {},
    )
  }

  async approveTransporter(simulationId){
    return this.request(
      this.resourceName()+"/approve_transporter/"+simulationId,
      "POST",
      {},
      {},
    )
  }

  async confirmOtherTransporter(hash,formData){
    return this.request(
      this.resourceName()+"/confirm_other_transporter/"+hash,
      "POST",
      {},
      formData
    )
  }

}

export default new Request();
